module.exports = __webpack_public_path__ + "img/delete-primary.e31ca42b.svg";